/*
 * Copyright (c) 2023. Vitalii Kozyr
 */

package tables.presentation.screen.schedule.model

enum class ScheduleLessonNumberOption(val number: Long) {
    N1(number = 1),
    N2(number = 2),
    N3(number = 3),
    N4(number = 4),
    N5(number = 5)
}